import axios from 'utils/axios';

export const activatePromo = (promo: string) => {
  return axios.put('/api/v1/servicepackages/my/activated', {
    promo
  });
};
